export const getAddressLink = (id: string) => {
  return `/addresses/${id}`
}
